module.exports = __webpack_public_path__ + "img/mtt_7.5.931714d3.png";